import React from 'react';

const ForbiddenModule = () => (
  <div style={{ padding: '150px 50px', textAlign: 'center' }}>No tienes acceso a esta sección</div>
);

export default ForbiddenModule;
